// src/utils/request.js
import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // 基础URL，可从环境变量获取
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加一些请求前的处理逻辑
    // 例如：显示loading、处理参数等
    return config
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做些统一处理
    const res = response.data

    // 根据实际业务情况调整判断逻辑
    if (response.status === 200) {
      return res
    } else {
      console.error('响应错误:', res.message)
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    // 处理响应错误
    console.error('响应错误:', error)
    return Promise.reject(error)
  }
)

export default service